export default {
  server_error: 'Something went wrong',
  robots_label: 'Robots attached to this event:',
  select_robots: 'Select robots!',
  select_events: 'Select event(s)!',
  organization: 'Organization:',
  delete_message:
    'Warning!\n\n All photos in this album will be permanently deleted from the server. This operation cannot be undone.\n\n If you used an e-mail method for sharing photos with guests at this event, those photos will also be gone, and users will not be able to view them using the link in the e-mail.\n\n Photos that users already downloaded to their devices, or shared on Facebook will not be affected.\n',
  valid_data: 'Please enter valid data.',
  unlimited_time: 'Available for unlimited time.',
  empty_album_default_text: 'There are no recent images in this album',
  delay_album_default_text: 'Pictures can be delayed by up to 2 hours',
  pp_album_default_text: 'Add a selfie or a portrait picture for each member of your party',
  no_event: 'No Event available.',
  add_event: 'Add Event',
  selected_message: 'Selected photos will be permanently removed from the album. This action cannot be undone. \n',
  remove_message:
    'Warning! Selected photos will be permanently removed from the album. This action cannot be undone. \n',
  album_message: 'Warning! Selected photos will be removed from the album.',
  print_message: 'Great! <br>Click OK to confirm, and your print will be ready in a minute.<br>',
  login_message: '<strong>Failed!</strong> User Name or Password is incorrect.',
  session_message: 'Your session has expired. Please log in again.',
  unsaved_message: 'You have unsaved changes.',
  album_available1: 'Available for',
  album_available2: 'minutes on photo stream.',
  kiosk_album: 'Kiosk Album',
  kiosk_stream: 'Kiosk Stream',
  error_name: 'Name can not contain numbers and special characters. ',
  error_email_name: 'Please enter valid E-mail address. ',
  error_phone_number: 'Please enter valid phone number. ',
  error_pc_event_list: 'Please select event(s). ',
  HELP_TEXTS: {
    kiosk_album_title:
      'Open this page on a separate kiosk station. Your users will be able to print and/or request pictures without having to use their phones.',
    kiosk_stream_title:
      'Open event album in thumbnail only mode on a separate Kiosk station (PC or a Tablet). Users will be able to e-mail the photos to themselves, but will not be able to zoom in to see larger photos. Note! Photos in event stream will expire as per album settings.',
    slide_show_title:
      'Use this to display photos from this event on an external monitor. This will let all of your your guests see photos from this event on a large screen.',
    email_body_title:
      "This is the e-mail text that will be sent to users at this event when they request photos. \n {user_name} and {album_link} are placeholders that will be filled out with user's real name and the link to a personal album, which will contain all requested images for that user across all events.",
    email_body_sharing_title:
      'When users at this event request and receive images, they can further share their photos with friends and family. \n This e-mail text will be offered to the user when she chooses to share her images with others via e-mail.',
    logo_link_title: 'Go to this web address if user clicks on album logo. Leave empty to disable clicking.',
  },
  upload_message: "The following '~\"$,#%&*:<>?{|} ' characters are NOT allowed in the file names.",
  print_photos_count_error:
    'You selected too many photos. Please specify the maximum of <limit> photos that you would like printed.',
  print_from_all_albums_disabled:
    'Printing physical photos for this event is enabled from kiosk station only.\nPrint your photos from the physical kiosk stand where OCCO is working.',
  copies_count_title: 'Select print copies count.',
  photos_copy_count_error:
    'Please enter a number between 1 and <limit> for the maximum number of copies of the same photo users can request to print.',
  per_request_count_error:
    'Please enter a number between 1 and <limit> for the maximum number of photos users can select to print in a single print request.',
  photo_delete_days_value_error:
    "Please enter a number between <min-limit> and <limit> for 'Photos auto delete (days)' field.",
  print_request_placeholder_error:
    'Sorry! The number of pictures to print should be a multiple of <b><count></b>. Select  <b> <count> </b>,  <b> <countx2> </b> or  <b> <countx3> </b> photos and try again.',
  max_photo_stream_avl_minutes_error:
    'Please specify number of minutes (between 1 and <limit>) to indicate when the Photos in the Event Stream must expire.',
  occo_photo_album: 'OCCO Photo Album',
  support: 'Support',
  sign_out: 'Sign Out',
  my_events: 'My Events',
  filter_by: 'Filter by',
  show_all: 'All ( <NUMBER> )',
  publicly_visible: 'Visible ( <NUMBER> )',
  hidden_from_public: 'Hidden ( <NUMBER> )',
  album_for_approval: 'Album for the approval and curation by the event host',
  copy_link: 'Copy Link',
  photos_expire: 'Album for sharing with guests/public (photos expire as per event settings)',
  photos_never_expire: 'Album for sharing with guests/public (photos never expire)',
  open_kiosk_stream: 'Open Kiosk Stream',
  event_add_edit: 'Event add/edit',
  edit_event: 'Edit Event',
  event: 'Event',
  general: 'General',
  e_mail_configuration: 'E-mail configuration',
  watermarks: 'Watermarks',
  photo_configuration: 'Photo configuration',
  album_logo: 'Event album logo',
  size_for_logo: 'Recommended size for logo is 320x40(px).',
  short_code: 'Event name (short code):',
  enable_printing: 'Use this code inside printer setup window on the print station to enable printing for this event.',
  album_title: 'Event album title',
  hashtags: 'Social media sharing hashtags:',
  disconnected_from: 'Selected robots will be disconnected from previous event',
  delete_event: 'Delete event permanently!',
  from_name: "'From Name' to appear on the e-mails sent to users when they request photos:",
  subject_line: 'Subject line to appear on e-mails sent to users when they request photos:',
  email_body: 'Email body',
  preview: 'Preview',
  enable_live: 'Enable Live Screen Watermark',
  png_size: 'Recommended png size: 1200 x 1800 (width x height pixels)',
  live_view_screen: "This image will be overlayed on top of OCCO's live view screen.",
  enable_watermark: 'Enable Watermark on Photos',
  recommended_png_size: 'Recommended png size: 1200 x 1800 (width x height pixels)',
  overlayed_on_top: 'This image will be overlayed on top of the photos that are uploaded to the album.',
  event_stream: 'Photos in the Event Stream must expires (minutes):',
  photo_auto_delete: 'Photos auto delete (hours):',
  auto_delete_photo_warn_massage:
    'Are you sure you want to set up automatic permanent deletion of photos? If this option is selected, all media accessed via links to this album will become unavailable to your end users after the specified expiry. We advise that you use this feature only to comply with legal requirements on data retention and you may want to communicate to your end users that unless they download copies of photos to their devices, they will not be able to access their pictures at a later time from an online album.',
  active_printer: 'Enable printing for this event',
  print_every_photo: 'Automatically print all photos',
  print_every_photo_note:
    'If this option is selected, each photo uploaded to this album will be immediately sent to printer once. Additional prints can be ordered by the attendees as usual, e.g. from their phones or from the kiosk. Note! Checking this option may result in high usage of paper media. Make sure that the printer is constantly monitored.',
  active_printer_note:
    "If you enable printing for this event, users will see a 'Print' option when they open this album either from their phones or from the kiosk.  \nNote! You will have to make sure that printer is connected to a PC where OCCO software is installed and configured to monitor this event. For more information on setting up a print station, refer to your OCCO user manual.",
  enable_printer_all_albums_note:
    'If this option is checked, users will not be able to print from their mobile devices. The print button on mobile devices will be grayed out and users will be asked to print from a kiosk station.',
  copy_count: 'Maximum number of copies of the same photo users can request to print',
  copy_count_note:
    'Use this setting to prevent users from printing too many copies of the same final composition (which may contain several photos as defined in the print template). E.g. a value of 3 would mean that a user can request up to 3 copies of the same photo or a strip.',
  photos_count: 'Maximum number of photos users can select to print in a single print request',
  photos_count_note:
    'Use this setting to limit the number of photos users can select and send to print. For example, setting this value to 6 would mean that if a user selects 7 or more photos and requests a printout - she will be asked to un-select some pictures to leave at most 6 in the selection. Note! If you are using a print template with more than one photo placeholder per printout - the final number of printed pages can be calculated using the formula: (number of photos users selected / number of placeholders in the print template)',
  distribution_models: 'Photo distribution models:',
  collect_leads: 'Collect leads when people request photos',
  direct_album: 'Direct album access (no leads collected)',
  add: '+ Add',
  update: 'Update',
  duplicate_event: 'Duplicate Event',
  save: 'Save',
  cancel: 'Cancel',
  great: 'Great!',
  click_ok: 'Click OK to confirm, and your print will be ready in a minute.',
  copies_count: 'Select print copies count.',
  ok: 'OK',
  preview_email: 'Preview Email',
  close: 'Close',
  hide: 'Hide',
  unhide: 'Unhide',
  print: 'Print',
  delete: 'Delete',
  username_and_password: 'Enter your username and password to log on',
  username: 'Username',
  password: 'Password',
  reset_your_password: 'To re-set your password please contact',
  image_save_text_mob:
    "Tap and hold an {file} to save it to your phone. <br><span id='iSB'><a href='javascript:open(location, \"_self\").close();'>back to album</a></span>",
  image_save_text_mob_android:
    "Tap and hold an {file} to save it to your phone. <br><span id='iSB'><a href='{loc_url}'>back to album</a></span>",
  image_save_text_pc:
    "Right click on {file} to save it to your PC.<br><span id='iSB'><a href='javascript:open(location, \"_self\").close();'>back to album</a></span>",
  delete_this_template: 'Are you sure you want to delete this template?',
  delete_confirm: 'Are you sure you want to delete?',
  background_message: 'Please select the background image.',
  placeholder_message: 'Print template must have at least one placeholder for user photos.',
  template_name_message: 'Please enter Printer Template name.',
  max_print_title: 'On-time maximum print count is ',
  reset_filter: 'Reset filter',
  title_required: 'Event album title is a required field.',
  emptyText_required: 'Event empty album text is a required field.',
  address_required: 'Email From Address is a required field.',
  name_required: 'Email From Name is a required field.',
  receipt_email_body_required: 'Receipt email body is a required field.',
  receipt_email_body_error:
    'Receipt email body text has to contain {user_name} strings which will be used to replace the actual values before sending the mail.',
  body_required: 'Email body is a required field.',
  body_error:
    'Email body text has to contain {user_name} and {image_url} strings which will be used to replace the actual values before sending the mail.',
  body_share_error:
    'Email body text has to contain {image_url} strings which will be used to replace the actual values before sending the mail.',
  sms_body_required: 'SMS body is a required field.',
  sms_body_error:
    'SMS body text has to contain {user_name} and {image_url} strings which will be used to replace the actual values before sending the SMS.',
  save_template: 'The template was saved successfully.',
  replace_temp_image: 'Replace Template Background Image',
  error_name_message: '"Your name" is required field.',
  single_rest:
    "You can share or download only one picture at a time. To do so, click \"enlarge\" <img class='enlargeIcon' src='img/max-white.png?v=1'/> button on individual photos.",
  occo_album: 'Info',
  template_close_confirm: 'Do you want to save changes made to this template?',
  new_template_name: 'Write new template name',
  valid_url: 'Please enter valid url.',
  valid_printer_pool_name:
    'A queue name is case-sensitive and can have up to 80 characters. You can use alphanumeric characters, hyphens ( - ), and underscores (  _  ).',
  multiple_email: 'Enter your email address followed by comma, space, tab or enter',
  add_valid_email: 'Add valid e-mail',
  get_images: 'Get images',
  please_read_text: 'Your privacy is very important to us, please read our {Privacy Policy}',
  privacy_policy_link_name: 'Privacy Policy',
  great_text: 'Great! <br><br>Check your inbox. You should see an e-mail from {from_name} very soon.',
  great_sms_text: 'Great! <br><br>Check your mobile. You should see an SMS from {from_name} very soon.',
  spam_check: "If you don't - check your spam folder.",
  error_generate_att_count_message: 'Please enter value between 1-200,000',
  success_generate_att_message: 'Please check your provided e-mail to get generated album list.',
  url_contains_white_spaces: "URL won't contain white spaces!",
  slide_show_minmax_intervals_error: 'Max interval needs to be more than Min interval.',
  generate_passCodes: 'Generate',
  update_passCodes: 'Update',
  generate_passCodes_window: 'Generate Pass Codes',
  update_passCodes_window: 'Update Pass Codes',
  something_wrong:
    "Something went wrong. Please <a href='javascript:location.reload()'> refresh </a> the page and try again.",
  unsupported_pic_format: 'Invalid or unsupported picture format',
  unsupported_pic_size:
    'Unsupported media size: Jpg file size should be under 1.5mb, mp4 file size should be under 4mb',
  invalid_attendee_id: 'Invalid attendee ID.',
  select_pipelines: 'Select Pipelines!',
  secret_codes_error: 'Please add Firstname/Lastname for event unlock codes.',
  unlock_code_error: 'Employee authorization code is invalid.',
  kiosk_time_expired: 'Sorry, public kiosk time is expired',
  attendee_time_expired: 'Sorry, attendee time is expired',
  provide_email_address: 'Hi, Please provide your email address.',
  unregister_face:
    'Remove this face from my collection? <br>New searches will not use this face. Note! Photos you already see in your album found based on this picture will still remain visible to you.',
  delete_image_1: 'Yes. This is not my picture',
  attached_successfully: 'Photos successfully attached to attendee. ',
  sharing_body_required: 'Photo html sharing is a required field.',
  sharing_video_body_required: 'Video html sharing is a required field.',
  sharing_360_body_required: '360 Photo html sharing is a required field',
  photo_tag_required: 'Photo tag is a required field',
  square_access_token_error: 'Square access token is invalid.',
  select_square_locations: 'Select Location',
  square_device_name_required: 'Device Name is a required field',
  square_location_required: 'Location is a required field',
  square_create_device_error: 'Creating device failed. Please try again.',
  square_get_device_error: 'Device code retrieval failed. Please try again.',
  square_checkout_creation_failed: 'Checkout request failed. Please try again later.',
  square_checkout_status_check_failed: 'Checkout status check failed. Please try again later.',
  square_checkout_cancellation_failed: 'Checkout cancellation failed. Please try again later.',
  receipt_email_sending_failed: 'Sending receipt via email failed.',
  payment_failed: 'Payment failed. Please try again later.',
  otp: {
    inputCode: {
      title: 'Input code from Authenticator App',
      submit: 'Submit',
      subtext: 'If you have lost access to the device with Authenticator app, please contact support.',
    },
  },
};
